__turbopack_context__.v({
  "about": "_183KKa_about",
  "backgroundContainer": "_183KKa_backgroundContainer",
  "blog": "_183KKa_blog",
  "blogBackground": "_183KKa_blogBackground",
  "body": "_183KKa_body",
  "clients": "_183KKa_clients",
  "container": "_183KKa_container",
  "description": "_183KKa_description",
  "firstScreen": "_183KKa_firstScreen",
  "footerSeparator": "_183KKa_footerSeparator",
  "getApplicationDraftForm": "_183KKa_getApplicationDraftForm",
  "hideMd": "_183KKa_hideMd",
  "mainContainer": "_183KKa_mainContainer",
  "showMd": "_183KKa_showMd",
  "showSm": "_183KKa_showSm",
  "supportContainer": "_183KKa_supportContainer",
  "tag": "_183KKa_tag",
  "title": "_183KKa_title",
  "trademarks": "_183KKa_trademarks",
});
